import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { mediaItems } from "@/mocks/mediaItems";
import { CATEGORY_LABELS } from "@/types";

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <span className="h-3 w-1 rounded-full bg-accent-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              Categories
            </span>
          </div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            三大主分类，快速直达
          </h2>
        </div>
        <p className="max-w-md text-sm text-foreground-500">
          电影、电视剧与综艺，按你感兴趣的方向，第一时间找到值得看的内容。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const count = mediaItems.filter((m) => m.category === cat.key).length;
          return (
            <Link
              key={cat.key}
              to={`/category?category=${cat.key}`}
              className="group relative flex h-56 flex-col justify-between overflow-hidden rounded-lg border border-background-200 p-6 transition-all duration-300 hover:border-primary-300"
            >
              <img
                src={cat.cover}
                alt={`${cat.name}分类封面`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-primary-950/10" />
              <div className="relative flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-50/95 text-primary-700">
                  <i className={`${cat.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="rounded-md bg-background-50/15 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                  共 {count} 条资讯
                </span>
              </div>
              <div className="relative">
                <h3 className="font-heading text-2xl font-bold text-background-50">
                  {CATEGORY_LABELS[cat.key]}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm text-background-100/85">{cat.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-400">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}